<template>
  <form>
    <user-form-field
      label="Proprietario"
      required
      :value="value.owner"
      disabled
      :error="findError('owner')"
    />

    <workgroup-form-field
      label="Gruppo di lavoro"
      required
      :value="value.workgroup"
      :disabled="disabled || !(value.permissions.changeWorkgroup || $route.params.id === 'new')"
      :error="findError('workgroup')"
      @input="propertyChanged('workgroup', $event)"
    />

    <div class="row">
      <string-form-field
        class="col-md-6"
        label="Codice fiscale"
        required
        to-upper-case
        :value="value.fiscalCode"
        :disabled="disabled"
        :error="findError('fiscalCode')"
        @input="propertyChanged('fiscalCode', $event)"
      />

      <string-form-field
        class="col-md-6"
        label="Partita IVA"
        to-upper-case
        :value="value.vatNumber"
        :disabled="disabled"
        :error="findError('vatNumber')"
        @input="propertyChanged('vatNumber', $event)"
      />
    </div>

    <div class="row">
      <string-form-field
        class="col-md-6"
        label="Provincia CCIAA"
        to-upper-case
        :value="value.cciaaCode"
        :disabled="disabled"
        :error="findError('cciaaCode')"
        @input="propertyChanged('cciaaCode', $event)"
      />

      <string-form-field
        class="col-md-6"
        label="Numero REA (senza provincia)"
        :value="value.reaNumber"
        :disabled="disabled"
        :error="findError('reaNumber')"
        @input="propertyChanged('reaNumber', $event)"
      />
    </div>

    <string-form-field
      label="Titolo"
      required
      :value="value.title"
      :disabled="disabled"
      :error="findError('title')"
      @input="propertyChanged('title', $event)"
    />

    <string-form-field
      label="Descrizione"
      :value="value.description"
      :disabled="disabled"
      :error="findError('description')"
      multiline
      @input="propertyChanged('description', $event)"
    />
  </form>
</template>
<script>
import EntityEditorMixin from 'vue-core/mixins/EntityEditorMixin';

export default {
  mixins: [ EntityEditorMixin ],
};
</script>
